import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { RAWBequest } from '../Models/RAWBequest';
import { forkJoin, lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-reading',
  templateUrl: './reading.component.html',
  styleUrls: ['./reading.component.css'],
  standalone: false
})
export class ReadingComponent implements OnInit {

  route = inject(ActivatedRoute);
  router = inject(Router);
  private loggedInUserTag = "";

  probateId: number = 0;

  RAWBequests: RAWBequest[] = []

  activeTab: string = 'will';
  sanitizedPdfUrl: SafeResourceUrl = '';
  pdfError: boolean = false;
  
  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

  ngOnInit() {

    this.extractRouteValues();

    this.populateComponents(this.probateId);

    this.updatePdfUrl();
  }

  extractRouteValues() {

    var probateIdAsString = this.route.snapshot.paramMap.get('id');

    this.probateId = Number(probateIdAsString);

    var loggedInUser = this.router.lastSuccessfulNavigation?.extras?.state?.['user'];
    this.loggedInUserTag = `${loggedInUser?.lastName}, ${loggedInUser?.firstName}`;

  }

  populateComponents(probateId: number) {

    forkJoin([
      this.getRAWBequests(probateId)
    ]).subscribe(results => {

      this.RAWBequests = results[0];

    })

  }

  async getRAWBequests(probateId: number) {

    //JP take all the settings and update them

    let parameters = new HttpParams()
      .set('user', this.loggedInUserTag)
      .set('probateId', probateId);

    var response = this.http.get<RAWBequest[]>("/charitycentral/getrawbequests", { params: parameters });

    return await lastValueFrom(response);

  }

  setActiveTab(tab: string) {
    this.activeTab = tab;
    this.pdfError = false; // Reset error state when switching tabs
    this.updatePdfUrl();
  }

  private updatePdfUrl() {
    const pdfUrl = this.getCurrentPdfUrl();
    this.sanitizedPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
  }

  onPdfLoad() {
    this.pdfError = false;
  }

  onPdfError() {
    this.pdfError = true;
  }

  getCurrentPdfUrl(): string {
    const url = this.activeTab === 'will' 
      ? '/assets/pdfs/1741083661830529_scanned_will_1_gop.pdf' 
      : '/assets/pdfs/1741083661830529_digitalGrant_gop.pdf';
    return url;
  }

  openInNewWindow() {
    const pdfUrl = this.getCurrentPdfUrl();
    // Open the actual PDF file in a new window/tab
    window.open(pdfUrl, '_blank');
  }

  onCharitableAction() {
    // Add your charitable action logic here
  }

  onNonCharitableAction() {
    // Add your non-charitable action logic here
  }

  onMissingPageAction() {
    // Add your missing page action logic here
  }
}
